(function () {

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem("wishlist") || "[]").filter(i => i && i.trim() !== "");
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem("wishlist", JSON.stringify([...new Set(list)]));
  }

  function updateCounter() {
    const counter = document.getElementById("wishlist-count");
    if (!counter) return;
    const list = getWishlist();
    counter.textContent = list.length;
    counter.style.display = list.length ? "flex" : "none";
  }

  function formatPrice(cents) {
    if (window.formatShopMoney) {
      return window.formatShopMoney(Number(cents));
    }
    return (cents / 100).toFixed(2);
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateCounter();

    document.querySelectorAll(".wishlist-btn, .custom-wishlist-btn").forEach(btn => {
      if (getWishlist().includes(btn.dataset.handle)) btn.classList.add("active");
    });

    const wishlistSection = document.querySelector(".wishlist-section");
    const container = document.getElementById("wishlist-products");
    if (!wishlistSection || !container) return;

    const showVariantSelector = wishlistSection.dataset.showVariantSelector === "true";
    const showAddToCart = wishlistSection.dataset.showAddToCart === "true";
    const buttonColor = wishlistSection.dataset.buttonColor || "#ff0000";
    const maxProducts = parseInt(wishlistSection.dataset.maxProducts) || Infinity;

    let wishlist = [...new Set(getWishlist())];
    saveWishlist(wishlist);

    if (!wishlist.length) {
      container.innerHTML = "<p class='wishlist-section__empty'>Your wishlist is empty.</p>";
      return;
    }

    Promise.all(
      wishlist.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null))
    ).then(products => {
      const valid = products.filter(Boolean).slice(0, maxProducts);
      if (!valid.length) {
        container.innerHTML = "<p class='wishlist-section__empty'>Your wishlist is empty.</p>";
        return;
      }

      container.innerHTML = "";

      valid.forEach(product => {
        const imgMain = product.images?.[0] || "https://via.placeholder.com/250";
        const div = document.createElement("div");
        div.className = "wishlist-section__item grid__item";
        div.dataset.firstVariant = product.variants[0].id;

        let variantHtml = "";

        if (showVariantSelector && product.variants.length > 1) {
          variantHtml += `<select class="wishlist-section__variant select__select">`;
          product.variants.forEach(v => {
            const img = v.featured_image?.src || imgMain;
            variantHtml += `<option value="${v.id}" data-image="${img}" data-price="${v.price}">${v.title} - ${formatPrice(v.price)}</option>`;
          });
          variantHtml += `</select>`;
        }

        if (showAddToCart) {
          variantHtml += `<button class="wishlist-section__add-btn quick-add__submit button ">Add to Cart</button>`;
        }

        div.innerHTML = `
          
          

          <div class="card-wrapper product-card-wrapper">
            <div class="card card--standard card--media">
              
              <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
                <div class="card__media">
                  <div class="media media--transparent media--hover-effect">
                    <img
                      src="${imgMain}"
                      alt="${product.title}"
                      class="motion-reduce wishlist-section__image"
                      loading="lazy"
                      width="533"
                      height="667"
                    >
                  </div>
                </div>
              </div>

              <div class="card__content">
                <div class="card__information">
                  <p class="card__heading">
                    <a href="/products/${product.handle}" class="full-unstyled-link">
                      ${product.title}
                    </a>
                  </p>

                  <div class="card-information">
                    
                  <div class="price">
                      <div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span class="price-item price-item--regular">
                              ${formatPrice(product.price)}
                            </span></div>
                        <div class="price__sale">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span>
                              <s class="price-item price-item--regular">
                              </s>
                            </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
                          <span class="price-item price-item--sale price-item--last">
                            ${formatPrice(product.price)}
                          </span>
                        </div></div></div>
                  </div>

                  ${variantHtml}
                  <button class="wishlist-section__remove-btn" data-handle="${product.handle}">✕</button>
                </div>
              </div>

            </div>
          </div>
        `;

        container.appendChild(div);
      });
    });

    container.addEventListener("change", function (e) {
      if (!e.target.classList.contains("wishlist-section__variant")) return;
      const opt = e.target.selectedOptions[0];
      const item = e.target.closest(".wishlist-section__item");
      if (opt.dataset.image) item.querySelector("img").src = opt.dataset.image;
      if (opt.dataset.price) item.querySelector(".wishlist-section__price").textContent = formatPrice(opt.dataset.price);
    });

    container.addEventListener("click", function (e) {

      const item = e.target.closest(".wishlist-section__item");
      if (!item) return;

      if (e.target.classList.contains("wishlist-section__remove-btn")) {
        wishlist = wishlist.filter(h => h !== e.target.dataset.handle);
        saveWishlist(wishlist);
        item.remove();
        updateCounter();
        if (!wishlist.length) container.innerHTML = "<p class='wishlist-section__empty'>Your wishlist is empty.</p>";
        return;
      }

      if (!e.target.classList.contains("wishlist-section__add-btn")) return;

      const select = item.querySelector(".wishlist-section__variant");
      const variantId = select ? select.value : item.dataset.firstVariant;
      if (!variantId) return;

      e.target.disabled = true;
      e.target.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(() => {
        document.body.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        return fetch("/cart?view=drawer").then(r => r.text());
      })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const ni = doc.querySelector("cart-drawer-items, .cart-items, [id*='CartItems'], .drawer__inner");
        const ti = document.querySelector("cart-drawer-items, .cart-items, #CartItems, .drawer__inner");
        if (ni && ti) ti.innerHTML = ni.innerHTML;

        const nb = doc.querySelector("#cart-icon-bubble, .cart-count-bubble, [data-cart-count]");
        const tb = document.querySelector("#cart-icon-bubble, .cart-count-bubble, [data-cart-count]");
        if (nb && tb) tb.outerHTML = nb.outerHTML;

        const drawer = document.querySelector("cart-drawer, #cart-drawer, .cart-drawer");
        if (drawer) {
          drawer.classList.remove("hidden", "is-empty");
          drawer.classList.add("active", "is-open");
          drawer.open?.();
        }

        document.querySelector(".drawer__inner-empty, .cart-empty")?.remove?.();
      })
      .finally(() => {
        e.target.disabled = false;
        e.target.textContent = "Add to Cart";
      });
    });
  });

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".wishlist-btn, .custom-wishlist-btn");
    if (!btn) return;

    e.preventDefault();

    if (btn.dataset.loggedIn === "false") {
      window.location.href = "/account/login";
      return;
    }

    const handle = btn.dataset.handle;
    if (!handle) return;

    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(h => h !== handle);
      btn.classList.remove("active");
    } else {
      wishlist.push(handle);
      btn.classList.add("active");
    }

    saveWishlist(wishlist);
    updateCounter();
  });

})();

document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("wishlist-products");
  const buttons = document.querySelectorAll(".view-btn");
  if (!container || !buttons.length) return;

  function apply(view) {
    container.classList.remove("grid-3", "grid-4");
    container.classList.add(view);
    buttons.forEach(b => b.classList.remove("active"));
    document.querySelector(`.view-btn[data-view="${view}"]`)?.classList.add("active");
    localStorage.setItem("wishlistView", view);
  }

  let view = localStorage.getItem("wishlistView");
  if (!["grid-3", "grid-4"].includes(view)) view = "grid-3";
  apply(view);

  buttons.forEach(b => b.addEventListener("click", () => apply(b.dataset.view)));
});